import React, { MouseEvent } from "react";
import * as _ from "lodash"
import { Formik, Field, Form, ErrorMessage } from "formik";

import * as SmartDrawings from "../../smartDrawings";
import { SettingsUtils } from "./settingsUtils";

/**
 * Renders the correct UI for all the custom settings defined in SettingsUtils.
 */

interface SettingsProps {
    viewer: Autodesk.Viewing.GuiViewer3D,
    setPanelVisible: (boolean) => void;
}

const NumberField = (props) => {
    return <div className="form-group row">
               <label className="col-formlabel col-sm-6">{props.label}</label>
               <div className="col-sm-6">
                   <Field type="number" name={props.name} className="form-control"/>
                   <ErrorMessage name={props.name} component="div"/>
               </div>
           </div>;
}

// TODO poista checked, kun tämä korjattu: https://github.com/jaredpalmer/formik/issues/1050
const CheckboxField = (props) => {
    return <div className="form-group row">
               <label className="col-form-label col-sm-6">{props.label}</label>
               <div className="col-sm-6 form-check">
                   <Field type="checkbox" className="form-check-input ml-0" name={props.name} checked={props.value}/>
                   <ErrorMessage name={props.name}>
                       {errorMessage => <div className="error">{errorMessage}</div>}
                   </ErrorMessage>
               </div>
           </div>;
}

const SelectOption = props => (<option value={props.value}>{props.label}</option>);

const SelectField = (props) => {
    return <div className="form-group row">
               <label className="col-form-label col-sm-6">{props.label}</label>
               <div className="col-sm-6">
                   <Field component="select" className="form-control" name={props.name}>
                       {props.values.map(v => (<SelectOption key={v.value} {...v}/>))}
                   </Field>
                   <ErrorMessage name={props.name}>
                       {errorMessage => <div className="error">{errorMessage}</div>}
                   </ErrorMessage>
               </div>
           </div>;
}

export default class SettingsList extends React.Component<SettingsProps> {

    constructor(props) {
        super(props);
    }

    private renderSettings(values) {
        return Object.keys(SettingsUtils.settingsMap).map(key => {
            const s = SettingsUtils.settingsMap[key];
            switch (s.type) {
            case "number":
                return <NumberField key={key} {...s} name={key}/>;
            case "boolean":
                return <CheckboxField key={key} {...s} name={key} value={values[key]}/>;
            case "enum":
                return <SelectField key={key} {...s} name={key}/>;
            default:
                return null;
            }
        });
    }

    private toggleAdvancedSettings = () => {
        const viewer = this.props.viewer as any;
        var panel = viewer.getSettingsPanel(true);
        if (!panel.isVisible()) {
            viewer.showViewer3dOptions(true);
        } else {
            viewer.showViewer3dOptions(false);
        }
    }

    render() {
        return (
            <Formik
                initialValues={SettingsUtils.loadSettings(SettingsUtils.settingsMap)}
                onSubmit={(values, actions) => {
                    SettingsUtils.saveSettings(values, SettingsUtils.settingsMap);
                    (this.props.viewer as any).setGhosting(values["ghosting"]);
                    actions.setSubmitting(false);
                    this.props.setPanelVisible(false);
                }}
                render={({ values, errors, status, touched, isSubmitting, handleReset, setValues }) => (
                    <Form className="container pt-3" style={{ width: "auto" }}>
                        {this.renderSettings(values)}

                        <button className="btn btn-secondary" type="button" disabled={isSubmitting} onClick={this.toggleAdvancedSettings}>
                            Advanced...
                        </button>
                        <button className="btn btn-secondary ml-1" type="button" disabled={isSubmitting} onClick={() => setValues(SettingsUtils.defaultSettings(SettingsUtils.settingsMap))}>
                            Restore defaults
                        </button>

                        <button className="btn btn-primary ml-5" type="submit" disabled={isSubmitting}>
                            Ok
                        </button>
                        <button className="btn btn-secondary ml-1" type="button" disabled={isSubmitting} onClick={() => this.props.setPanelVisible(false)}>
                            Cancel
                        </button>
                    </Form>
                )}/>
        );
    }
}